import ProductService from '_services/rest/modules/product';

export default {
  state: {
    product: null,
    equipments: null,
    productList: null,
    productType: null,
  },
  mutations: {
    setProduct(state, response) {
      state.product = response;
    },
    setEquipments(state, response) {
      state.equipments = response;
    },
    setProductList(state, response) {
      state.productList = response;
    },
    setProductType(state, response) {
      state.productType = response;
    },
  },
  actions: {
    getProductList({ commit }, params) {
      return ProductService.getList(params)
        .then(response => {
          commit('setProductList', response);
        });
    },
    getProduct({ commit }, params) {
      return ProductService.getProductById(params)
        .then(response => {
          commit('setProduct', response);
        });
    },
    getEquipments({ commit }, params) {
      return ProductService.getEquipments(params)
        .then(response => {
          commit('setEquipments', response);
        });
    },
    setProduct({ commit }, params) {
      commit('setProduct', params);
    },
    getProductType({ commit }) {
      return ProductService.getProductTypeOptions()
        .then(response => {
          commit('setProductType', response);
        });
    },
  },
};
